var map = {
	"./asset.svg": "b538",
	"./chart-pie.svg": "2872",
	"./data.svg": "5a0a",
	"./driver.svg": "e85c",
	"./finance.svg": "b599",
	"./maintain.svg": "dcb8",
	"./marketing.svg": "ca71",
	"./merchant.svg": "9154",
	"./operation.svg": "1c17",
	"./order.svg": "11ff",
	"./sys.svg": "7213"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";